import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c0c2effe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c0c2effe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c2effe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0c2effe')) {
      api.createRecord('c0c2effe', component.options)
    } else {
      api.reload('c0c2effe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c0c2effe&scoped=true", function () {
      api.rerender('c0c2effe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-economic/index.vue"
export default component.exports